import { api } from '../http';

export const getCompanyKeys = companyId => api.get(`/companies/${companyId}/keys`);

export const insertCompanyKey = (companyId, data) => api.post(`/companies/${companyId}/keys`, data);

export const removeCompanyKey = (companyId, keyId) =>
  api.delete(`/companies/${companyId}/keys/${keyId}`);
